import styled from '@emotion/styled';

export const ProgressBar = styled.div`
  top: 0;
  left: 0;
  z-index: 95;
  height: 3.5rem;
`;

export const StepNumber = styled.div`
  width: 1.5rem;
  height: 1.5rem;
`;
